<template functional>
  <div class="row no-gutters ls-bg-3e3e3e py-3" v-if="props.contract">
    <div class="col-md-3 col-6 col-lg-3 col-xl-2 col col-12 c-white s-14 d-flex justify-content-md-center pl-3">
      <span class="mr-1" v-if="props.contract.contact && parent.getSalutation(props.contract.contact)">
        {{ parent.getSalutation(props.contract.contact) }}
      </span>
      <span>
        {{ props.contract.contact.full_name }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContractBar',
};
</script>
